import React from 'react';

import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {HealthBooking as HealthBookingDeprecated} from 'presentation/pages/private/booking/pages';
import {HealthBooking} from 'presentation/modules/booking/health/ui/pages/HealthBooking';

export const MakeHealthBooking = () => {
	const {isEnabled: showHealthRefactor} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_REFACTOR_BOOKING_HEALTH,
	);

	if (showHealthRefactor) {
		return <HealthBooking />;
	}

	return <HealthBookingDeprecated />;
};
